import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "./AuthContext";

const ProjectCtx = createContext(null);

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem("pruva_project") || null);

  const { data: projects = [], isLoading, refetch } = useQuery({
    queryKey: ["my-projects"],
    queryFn: async () => (await api.get("/my/projects")).data,
    enabled: !!user,
  });

  useEffect(() => {
    if (projects.length && !projects.find((p) => p.id === selectedId)) {
      setSelectedId(projects[0].id);
    }
  }, [projects, selectedId]);

  useEffect(() => {
    if (selectedId) localStorage.setItem("pruva_project", selectedId);
  }, [selectedId]);

  const project = projects.find((p) => p.id === selectedId) || null;

  const value = useMemo(
    () => ({ projects, project, selectedId, setSelectedId, isLoading, refetch }),
    [projects, project, selectedId, isLoading, refetch]
  );

  return <ProjectCtx.Provider value={value}>{children}</ProjectCtx.Provider>;
}

export const useProject = () => useContext(ProjectCtx);
